import script from "./MenuBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBar.vue?vue&type=script&setup=true&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=52dd2017&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52dd2017"]])

export default __exports__